import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnGN: CultureInfo = {
  name: 'ff-Latn-GN',
  displayName: 'Pulaar (Latn, Gine)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-GN',
  parent: CultureInfoFfLatn
};
